module.exports = __webpack_public_path__ + "static/assets/1a459fb9ec644b013da6b849d2cffce2.gif";